var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 100,
    width: 140,
    height: 170,
    rx: 10,
    fill: "#80CBC4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 130,
    width: 140,
    height: 140,
    rx: 10,
    fill: "#4DB6AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 160,
    width: 140,
    height: 110,
    rx: 10,
    fill: "#26A69A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.9d389bf0bfa31de25e2c3df84baeda94.svg";
export { ForwardRef as ReactComponent };